var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-512 -240)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6659ff",
    d: "M525.898 257.13a1.14 1.14 0 01-.525-.127l-3.75-1.958a.75.75 0 00-.698 0l-.855.45a.75.75 0 11-.698-1.327l.855-.45a2.246 2.246 0 012.093 0l3.045 1.604-.585-3.39a2.251 2.251 0 01.645-1.987l2.497-2.445-3.405-.495a2.248 2.248 0 01-1.694-1.23l-1.5-3.083-1.5 3.083a2.25 2.25 0 01-1.733 1.26l-3.405.465 2.467 2.4c.531.518.772 1.264.646 1.995l-.713 4.14a.762.762 0 01-1.5-.255l.713-4.14a.754.754 0 00-.218-.668l-3-2.932a1.126 1.126 0 01.622-1.92l4.155-.607a.75.75 0 00.563-.413l1.86-3.75a1.125 1.125 0 012.017 0l1.86 3.75c.109.222.32.376.563.413l4.155.607c.424.062.776.359.909.766.132.408.02.855-.287 1.154l-3 2.933a.748.748 0 00-.217.66l.72 4.177c.058.328-.033.664-.247.92-.214.254-.53.4-.863.4h.008z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cc3dc60d.svg";
export { ForwardRef as ReactComponent };